module.exports = __webpack_public_path__ + "media/EXAC_intro.2d3b5efd.mp4";